import React from "react";
import styles from "./Status-badge.module.css";

interface StatusBadgeProps {
  children: React.ReactNode;
  type?: string;
  scale?: number;
  fontSize?: string;
  circleSize?: string;
}

const BADGE_STYLES: Record<
  string,
  { badge: string; circle: string; color: string }
> = {
  active: {
    badge: styles["badge-active"],
    circle: styles["circle-active"],
    color: "#30bb67",
  },
  test: {
    badge: styles["badge-test"],
    circle: styles["circle-test"],
    color: "#ffa722",
  },
  error: {
    badge: styles["badge-error"],
    circle: styles["circle-error"],
    color: "#d83a3a",
  },
  issued: {
    badge: styles["badge-issued"],
    circle: styles["circle-issued"],
    color: "#3b82f6",
  },
  inflicted: {
    badge: styles["badge-inflicted"],
    circle: styles["circle-inflicted"],
    color: "#0d9488",
  },
  aggregated: {
    badge: styles["badge-aggregated"],
    circle: styles["circle-aggregated"],
    color: "#7c3aed",
  },
  deaggregated: {
    badge: styles["badge-deaggregated"],
    circle: styles["circle-deaggregated"],
    color: "#d97706",
  },
};

function StatusBadge({
  children,
  type,
  scale = 1,
  fontSize = "16px",
  circleSize = "8px",
}: StatusBadgeProps) {
  const theme = (type && BADGE_STYLES[type]) || null;
  const badgeClass = theme
    ? `${styles.badge} ${theme.badge}`
    : styles.badge;
  const circleClass = theme
    ? `${styles.circle} ${theme.circle}`
    : styles.circle;

  return (
    <div
      className={badgeClass}
      style={{ transform: `scale(${scale})`, fontSize }}
    >
      <div
        className={circleClass}
        style={{
          width: circleSize,
          height: circleSize,
          backgroundColor: theme?.color || "#678aa1",
        }}
      />
      {children}
    </div>
  );
}

export default StatusBadge;
